module.exports = __webpack_public_path__ + "static/media/Parking2.fa67dd60.jpg";